const BrazilCarbonUniversalCredit1155 = {
  "_format": "hh-sol-artifact-1",
  "contractName": "BrazilCarbonUniversalCredit1155",
  "sourceName": "contracts/core/BrazilCarbonUniversalCredit1155.sol",
  "abi": [
    {
      "inputs": [],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "inputs": [],
      "name": "BRAZIL_ONLY_STATUS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "BUFFER_ACCOUNT_NOT_SET",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "BUFFER_UNDERFLOW",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "DETOKENIZATION_DISABLED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "EMPTY_STRING",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INVALID_HOST_COUNTRY",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INVALID_STATE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INVALID_SUPPLY",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INVALID_TIME_RANGE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "KYC_REQUIRED",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "field",
          "type": "uint8"
        }
      ],
      "name": "MISSING_REQUIRED_HASH",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "SERIES_ALREADY_EXISTS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "SERIES_NOT_FOUND",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "SUPPLY_CAP_EXCEEDED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "TRANSFER_BLOCKED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "UNAPPROVED_OPERATOR",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_ADDRESS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_AMOUNT",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "previousAdmin",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "newAdmin",
          "type": "address"
        }
      ],
      "name": "AdminChanged",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "approved",
          "type": "bool"
        }
      ],
      "name": "ApprovalForAll",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "approved",
          "type": "bool"
        }
      ],
      "name": "ApprovedOperatorSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "beacon",
          "type": "address"
        }
      ],
      "name": "BeaconUpgraded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "BufferAccountSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "reasonHash",
          "type": "bytes32"
        }
      ],
      "name": "BufferMoved",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "reasonHash",
          "type": "bytes32"
        }
      ],
      "name": "BufferReleased",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "reasonHash",
          "type": "bytes32"
        }
      ],
      "name": "Cancelled",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "string",
          "name": "newContractURI",
          "type": "string"
        }
      ],
      "name": "ContractURISet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "destinationRef",
          "type": "bytes32"
        }
      ],
      "name": "Detokenized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "destinationRef",
          "type": "bytes32"
        }
      ],
      "name": "Exported",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "whitelist",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "enabled",
          "type": "bool"
        }
      ],
      "name": "KYCWhitelistSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "bool",
          "name": "enabled",
          "type": "bool"
        }
      ],
      "name": "OperatorFilteringSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "Paused",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "syncHash",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "syncURIHash",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "uint64",
          "name": "syncedAt",
          "type": "uint64"
        }
      ],
      "name": "RegistrySyncRecorded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "beneficiaryRef",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "purposeRef",
          "type": "bytes32"
        }
      ],
      "name": "Retired",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "previousAdminRole",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "newAdminRole",
          "type": "bytes32"
        }
      ],
      "name": "RoleAdminChanged",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleGranted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleRevoked",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "evidenceHash",
          "type": "bytes32"
        }
      ],
      "name": "SeriesComplianceUpdated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "enum BrazilCarbonUniversalCredit1155.StandardProfile",
          "name": "standard",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "bytes16",
          "name": "registryProgram",
          "type": "bytes16"
        },
        {
          "indexed": false,
          "internalType": "bytes16",
          "name": "projectId",
          "type": "bytes16"
        },
        {
          "indexed": false,
          "internalType": "uint32",
          "name": "supplyCap",
          "type": "uint32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "initialHolder",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint32",
          "name": "initialMintAmount",
          "type": "uint32"
        }
      ],
      "name": "SeriesCreated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "evidenceHash",
          "type": "bytes32"
        }
      ],
      "name": "SeriesMinted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "enum BrazilCarbonUniversalCredit1155.SeriesState",
          "name": "newState",
          "type": "uint8"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "reasonHash",
          "type": "bytes32"
        }
      ],
      "name": "SeriesStateUpdated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "string",
          "name": "newTokenURI",
          "type": "string"
        }
      ],
      "name": "TokenURISet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "ids",
          "type": "uint256[]"
        },
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "values",
          "type": "uint256[]"
        }
      ],
      "name": "TransferBatch",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "TransferSingle",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "string",
          "name": "value",
          "type": "string"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        }
      ],
      "name": "URI",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "Unpaused",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "implementation",
          "type": "address"
        }
      ],
      "name": "Upgraded",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "COMPLIANCE_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "DEFAULT_ADMIN_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "ISSUER_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "OPERATOR_ADMIN_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "PAUSER_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "URI_MANAGER_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "approvedOperator",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address[]",
          "name": "accounts",
          "type": "address[]"
        },
        {
          "internalType": "uint256[]",
          "name": "ids",
          "type": "uint256[]"
        }
      ],
      "name": "balanceOfBatch",
      "outputs": [
        {
          "internalType": "uint256[]",
          "name": "",
          "type": "uint256[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "bufferAccount",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "bytes32",
          "name": "reasonHash",
          "type": "bytes32"
        }
      ],
      "name": "cancelFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "contractURI",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "enum BrazilCarbonUniversalCredit1155.StandardProfile",
              "name": "standard",
              "type": "uint8"
            },
            {
              "internalType": "enum BrazilCarbonUniversalCredit1155.UnderlyingControl",
              "name": "underlyingControl",
              "type": "uint8"
            },
            {
              "internalType": "enum BrazilCarbonUniversalCredit1155.AssetType",
              "name": "assetType",
              "type": "uint8"
            },
            {
              "internalType": "bytes2",
              "name": "hostCountryISO",
              "type": "bytes2"
            },
            {
              "internalType": "uint16",
              "name": "vintage",
              "type": "uint16"
            },
            {
              "internalType": "uint64",
              "name": "monitoringStart",
              "type": "uint64"
            },
            {
              "internalType": "uint64",
              "name": "monitoringEnd",
              "type": "uint64"
            },
            {
              "internalType": "uint64",
              "name": "issuanceDate",
              "type": "uint64"
            },
            {
              "internalType": "uint32",
              "name": "supplyCap",
              "type": "uint32"
            },
            {
              "internalType": "uint32",
              "name": "initialMintAmount",
              "type": "uint32"
            },
            {
              "internalType": "address",
              "name": "initialHolder",
              "type": "address"
            },
            {
              "internalType": "bytes16",
              "name": "registryProgram",
              "type": "bytes16"
            },
            {
              "internalType": "bytes16",
              "name": "methodology",
              "type": "bytes16"
            },
            {
              "internalType": "bytes16",
              "name": "registryReference",
              "type": "bytes16"
            },
            {
              "internalType": "bytes16",
              "name": "projectId",
              "type": "bytes16"
            },
            {
              "internalType": "bytes8",
              "name": "methodologyVersion",
              "type": "bytes8"
            },
            {
              "internalType": "string",
              "name": "metadataURI",
              "type": "string"
            },
            {
              "internalType": "bytes32",
              "name": "serialManifestURIHash",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "serialManifestHash",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "registryConsentHash",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "underlyingControlProofHash",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "verificationReportHash",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "legalAuthorizationHash",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "correspondingAdjustmentProofHash",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "additionalDataHash",
              "type": "bytes32"
            },
            {
              "internalType": "uint256",
              "name": "complianceFlags",
              "type": "uint256"
            }
          ],
          "internalType": "struct BrazilCarbonUniversalCredit1155.SeriesInput",
          "name": "input",
          "type": "tuple"
        }
      ],
      "name": "createSeries",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "bytes32",
          "name": "destinationRef",
          "type": "bytes32"
        }
      ],
      "name": "detokenize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        }
      ],
      "name": "exists",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "bytes32",
          "name": "destinationRef",
          "type": "bytes32"
        }
      ],
      "name": "exportForInternationalTransfer",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        }
      ],
      "name": "getRoleAdmin",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "getSeriesAccounting",
      "outputs": [
        {
          "components": [
            {
              "internalType": "uint32",
              "name": "issued",
              "type": "uint32"
            },
            {
              "internalType": "uint32",
              "name": "retired",
              "type": "uint32"
            },
            {
              "internalType": "uint32",
              "name": "cancelled",
              "type": "uint32"
            },
            {
              "internalType": "uint32",
              "name": "detokenized",
              "type": "uint32"
            },
            {
              "internalType": "uint32",
              "name": "exported",
              "type": "uint32"
            },
            {
              "internalType": "uint32",
              "name": "bufferReserved",
              "type": "uint32"
            }
          ],
          "internalType": "struct BrazilCarbonUniversalCredit1155.SeriesAccounting",
          "name": "",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "getSeriesCompliance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "getSeriesCore",
      "outputs": [
        {
          "components": [
            {
              "internalType": "uint32",
              "name": "supplyCap",
              "type": "uint32"
            },
            {
              "internalType": "bytes2",
              "name": "hostCountryISO",
              "type": "bytes2"
            },
            {
              "internalType": "bytes32",
              "name": "legalAuthorizationHash",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "correspondingAdjustmentProofHash",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "metadataHash",
              "type": "bytes32"
            }
          ],
          "internalType": "struct BrazilCarbonUniversalCredit1155.SeriesCore",
          "name": "",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "grantRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "hasRole",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "string",
          "name": "name_",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "symbol_",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "contractURI_",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "baseURI_",
          "type": "string"
        },
        {
          "internalType": "address",
          "name": "admin_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "issuer_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "complianceAdmin_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "kycWhitelist_",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "kycEnabled_",
          "type": "bool"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "operator",
          "type": "address"
        }
      ],
      "name": "isApprovedForAll",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "kycEnabled",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "kycWhitelist",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint32",
          "name": "amount",
          "type": "uint32"
        },
        {
          "internalType": "bytes32",
          "name": "evidenceHash",
          "type": "bytes32"
        }
      ],
      "name": "mintExistingSeries",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "bytes32",
          "name": "reasonHash",
          "type": "bytes32"
        }
      ],
      "name": "moveToBuffer",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "name",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "nextTokenId",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "operatorFilteringEnabled",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "pause",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "paused",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "proxiableUUID",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "bytes32",
          "name": "syncHash",
          "type": "bytes32"
        },
        {
          "internalType": "bytes32",
          "name": "syncURIHash",
          "type": "bytes32"
        }
      ],
      "name": "recordRegistrySync",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "bytes32",
          "name": "reasonHash",
          "type": "bytes32"
        }
      ],
      "name": "releaseFromBuffer",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "renounceRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "bytes32",
          "name": "beneficiaryRef",
          "type": "bytes32"
        },
        {
          "internalType": "bytes32",
          "name": "purposeRef",
          "type": "bytes32"
        }
      ],
      "name": "retire",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "revokeRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256[]",
          "name": "ids",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "amounts",
          "type": "uint256[]"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "safeBatchTransferFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "safeTransferFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "seriesExists",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "approved",
          "type": "bool"
        }
      ],
      "name": "setApprovalForAll",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "approved",
          "type": "bool"
        }
      ],
      "name": "setApprovedOperator",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "setBufferAccount",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "string",
          "name": "newContractURI",
          "type": "string"
        }
      ],
      "name": "setContractURI",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "whitelist",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "enabled",
          "type": "bool"
        }
      ],
      "name": "setKYCWhitelist",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bool",
          "name": "enabled",
          "type": "bool"
        }
      ],
      "name": "setOperatorFilteringEnabled",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "enum BrazilCarbonUniversalCredit1155.SeriesState",
          "name": "newState",
          "type": "uint8"
        },
        {
          "internalType": "bytes32",
          "name": "reasonHash",
          "type": "bytes32"
        }
      ],
      "name": "setSeriesState",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "string",
          "name": "newTokenURI",
          "type": "string"
        }
      ],
      "name": "setTokenURI",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes4",
          "name": "interfaceId",
          "type": "bytes4"
        }
      ],
      "name": "supportsInterface",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "symbol",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        }
      ],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "unpause",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "newFlags",
          "type": "uint256"
        },
        {
          "internalType": "bytes32",
          "name": "evidenceHash",
          "type": "bytes32"
        }
      ],
      "name": "updateSeriesCompliance",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        }
      ],
      "name": "upgradeTo",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "upgradeToAndCall",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "uri",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    }
  ],
  "bytecode": "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__$f1f34f343d03d963adfb7a00eec90e9d69$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$f1f34f343d03d963adfb7a00eec90e9d69$__5af4908115610aa4576000916121d4575b50600181146121bc576002811461061c576003146121aa57611c2b6020611bf760646004350161401a565b6040518093819263788d549b60e11b83526102e46004350135906102c46004350135906103246004350135600486016140be565b038173__$f1f34f343d03d963adfb7a00eec90e9d69$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",
  "deployedBytecode": "0x6080604052600436101561001257600080fd5b60003560e01c8062fdd58e14613a8057806301ffc9a7146139f8578063062d3bd7146139cf57806306fdde031461393c5780630e89341c146138475780630fa41b66146137e5578063112356d714613751578063162094c4146135ff5780632328184014613595578063248a9ca3146135665780632eb2c2d6146131f65780632f2ff15d14613155578063318521c91461307857806336568abe14612fe65780633659cfe614612e5e5780633c5a615314612dd25780633c7eb38d14612da05780633f4ba83a14612d0c578063428ecf1b14612c1d5780634e1273f414612a845780634f1ef2861461280d5780634f558e79146127de57806352d0c4f0146126df57806352d1902d146126205780635403fab6146125285780635c975abb146125055780635d633e98146124c05780636033a28f146123ed578063674abf42146123ad578063682d07d91461238457806374a489c71461199e57806375794a3c1461197f5780637e1a90ff1461195557806382aefa241461192c578063833a2f3a146118295780638456cb59146117cf578063876aa62514610de0578063903431f714610cde57806391d1485414610c91578063938e3d7b14610b4357806395d89b4114610ab057806399ade45614610939578063a217fddf1461091d578063a22cb46514610832578063a6fcb0531461080b578063b0d4c8aa146107e1578063b7c0b8e814610774578063bd85b03914610747578063d547741f14610708578063d6f2f10c14610692578063dac500e314610669578063e63ab1e914610640578063e7bc05131461052f578063e8a3d48514610461578063e985e9c51461040a578063ef3d230d14610370578063f242432a146102c55763fb796e6c1461029957600080fd5b346102c05760003660031901126102c057602060ff6101c65460a81c166040519015158152f35b600080fd5b346102c05760a03660031901126102c0576102de613aaf565b6102e6613ac5565b60843591906001600160401b0383116102c05761030a610347933690600401613cd5565b91610313614982565b61031c81614c34565b6001600160a01b0381163381148015610349575b61033a9150614cfa565b60643591604435916150ab565b005b5060005261016060205260406000203360005260205261033a60ff60406000205416610330565b346102c0576003196060368201126102c057600435906024359060038210156102c05761039b61450a565b826000526101ca60205260ff60406000205416156103f857826000526101cc60205260406000209081541660038316179055604435917f33f6a212e61dc6e8abb22e5c8cdf121399cab0e22652aedb68b05ae0a9233bfc600080a4005b6040516319265e1760e31b8152600490fd5b346102c05760403660031901126102c057610423613aaf565b61042b613ac5565b9060018060a01b0380911660005261016060205260406000209116600052602052602060ff604060002054166040519015158152f35b346102c05760003660031901126102c0576040516101c5805482600061048683613adb565b928383526020946001918660018216918260001461050d5750506001146104ce575b50506104b692500383613b9c565b6104ca604051928284938452830190613be2565b0390f35b85925060005281600020906000915b8583106104f55750506104b6935082010185806104a8565b805483890185015287945086939092019181016104dd565b92509350506104b694915060ff191682840152151560051b82010185806104a8565b346102c05761053d36613d7e565b9190610547614982565b61054f614d5d565b816000526101ca60205260ff60406000205416156103f857801561062e57816000526101cc602052618000604060002054161561061c5761058f33614db4565b61059a818333614e37565b6105e863ffffffff836000526101cd6020526105c460406000209180851690835460601c16613f06565b90805463ffffffff60601b191660609290921b63ffffffff60601b16919091179055565b6040519081527fdf4ac32834e3c38949e0b0fea14040cb64fecda41d8d3c91817c0722e093be8e60203392a4600161012d55005b60405163211fc93560e11b8152600490fd5b604051630f6fa54560e41b8152600490fd5b346102c05760003660031901126102c0576020604051600080516020615d198339815191528152f35b346102c05760003660031901126102c0576020604051600080516020615d598339815191528152f35b346102c05760603660031901126102c0576004356106ae61450a565b806000526101ca60205260ff60406000205416156103f857604080516044358152426001600160401b0316602082015260243592917fc3085bca875b75b6c81567689dcb5c744c1cdc686abf3c2d0043a665613fcbe491a3005b346102c05760403660031901126102c057610347600435610727613ac5565b908060005260c9602052610742600160406000200154614882565b614f7c565b346102c05760203660031901126102c0576004356000526101916020526020604060002054604051908152f35b346102c05760203660031901126102c0576004358015158091036102c05760207fc4dac389b977cf704ae43d09ea242b5dc6678bf75a427137d472ca9ce98a50ea916107be614632565b6101c6805460ff60a81b191660a883901b60ff60a81b16179055604051908152a1005b346102c05760003660031901126102c0576101c6546040516001600160a01b039091168152602090f35b346102c05760003660031901126102c057602060ff6101c65460a01c166040519015158152f35b346102c05760403660031901126102c05761084b613aaf565b610853613c07565b6001600160a01b03909116903382146108c657336000526101606020526040600020826000526020526108968160406000209060ff801983541691151516179055565b60405190151581527f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c3160203392a3005b60405162461bcd60e51b815260206004820152602960248201527f455243313135353a2073657474696e6720617070726f76616c20737461747573604482015268103337b91039b2b63360b91b6064820152608490fd5b346102c05760003660031901126102c057602060405160008152f35b346102c05761094736613d7e565b919061095161450a565b8160005260206101ca815260ff60406000205416156103f857826000526101cb815260406000208161ffff60f01b825460d01b169160026001820154910154926109b0604051948593849363bd4e4cd960e01b855289600486016140be565b038173__$f1f34f343d03d963adfb7a00eec90e9d69$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$f1f34f343d03d963adfb7a00eec90e9d69$__5af4908115610aa4576000916121d4575b50600181146121bc576002811461061c576003146121aa57611c2b6020611bf760646004350161401a565b6040518093819263788d549b60e11b83526102e46004350135906102c46004350135906103246004350135600486016140be565b038173__$f1f34f343d03d963adfb7a00eec90e9d69$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",
  "linkReferences": {
    "contracts/core/ComplianceLib.sol": {
      "ComplianceLib": [
        {
          "length": 20,
          "start": 2715
        },
        {
          "length": 20,
          "start": 7311
        },
        {
          "length": 20,
          "start": 7446
        }
      ]
    }
  },
  "deployedLinkReferences": {
    "contracts/core/ComplianceLib.sol": {
      "ComplianceLib": [
        {
          "length": 20,
          "start": 2484
        },
        {
          "length": 20,
          "start": 7080
        },
        {
          "length": 20,
          "start": 7215
        }
      ]
    }
  }
};

export default BrazilCarbonUniversalCredit1155;
